import { __decorate } from "tslib";
import { Mixins, Component, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { maxLength } from 'vuelidate/lib/validators';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import ActionButton from '@/components/action_button/Index.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import PageSettingMixin from '@/helpers/vue_mixins/v2/PageSettingMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CopyToClipboardMixin from '@/helpers/vue_mixins/v2/CopyToClipboardMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let NotificationsEmail = class NotificationsEmail extends Mixins(Mixins(PageSettingMixin, FormValidationsMixin, validationMixin, ViewportSizeMixin, ButtonLoaderMixin), CopyToClipboardMixin, AlertMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.userNameTag = '<<user_name>>';
        this.refNoTag = '<<reference_number>>';
        this.appNameTag = '<<app_name>>';
        this.salesChannelTag = '<<sales_channel>>';
        this.supportEmailAddressTag = '<<support_email_address>>';
        this.supportContactNumberTag = '<<support_contact_number>>';
        this.form = {
            miniAppNotifications: [],
        };
    }
    cancelledNotifHint(label) {
        const defaultHint = 'Email addresses are not allowed in this entry. Dots/periods should be followed by a whitespace.';
        if (label.includes('Cancelled')) {
            return `Supports cancel_message tag to be replaced by actual order cancellation message. ${defaultHint}`;
        }
        return defaultHint;
    }
    notificationObserver(data) {
        if (data && this.app) {
            const miniAppNotifications = this.formData.miniAppNotifications.filter(({ category }) => /email|reminder/.test(category));
            Object.assign(this.form, { ...this.form, ...{ miniAppNotifications } });
        }
    }
    async onSubmit() {
        this.requestOnFlight();
        await this.updateMiniAppNotifs(this.form)
            .then(() => {
            this.requestDone();
            this.notificationManagerAction('SUBMIT EDIT', 'EMAIL');
            this.successNotification('Successfully Updated');
        })
            .catch((e) => {
            this.requestDone();
            this.errorNotification(e.message);
        });
    }
};
__decorate([
    Watch('miniAppNotificationsByApp', { deep: true })
], NotificationsEmail.prototype, "notificationObserver", null);
NotificationsEmail = __decorate([
    Component({
        components: {
            BaseTextArea,
            BaseTextField,
            ActionButton,
            BaseOverlayLoader,
        },
        validations: {
            form: {
                miniAppNotifications: {
                    $each: {
                        content: {
                            maxLength: maxLength(200),
                        },
                        label: {},
                        active: {},
                    },
                },
            },
        },
    })
], NotificationsEmail);
export default NotificationsEmail;
